import { AxiosResponse } from "axios";
import RequestUtilitario, { BasicQueryType } from "../../../../Utils/RequisicaoUtilitario";
import Especie from "../../../../Models/Financeiro/Conta/Remessa/Especie";
import { useQuery } from "@tanstack/react-query";
import { Axios } from "../../../Axios";

export function useEspecieListar({
    especie,
    ativo,
    select,
    ...rest
}:BasicQueryType<AxiosResponse<Especie[]|null>, {
    especie?:Especie,
    ativo?:boolean
}>) {
    const queryString = RequestUtilitario.objectToQueryString({
        ...(especie ?? {}),
        especieAtiva : ativo
    });

    return useQuery({
        ...rest,
        queryKey : ["Financeiro.Conta.Remessa.Especie.Listar", `Financeiro.Conta.Remessa.Especie.Listar?${queryString}`],
        queryFn : () => Axios.get<Especie[]>(`financeiro/conta/remessa/especie?${queryString}`),
        select : (response) => {
            let data = response.data ?? [] as Especie[];
            data.map(m => {
                return {
                    ...m,
                    dataCriacao : new Date(m.dataCriacao as any)
                }
            });
            response = select?.(response) ?? response;
            return response;
        },
        staleTime : 1000 * 60 * 5 // 5 minuto
    });
}